import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import Container from "../hoc/Container";

function OfferPage() {
  const location = useLocation();
  const [content, setContent] = useState("");
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    const path = "/offer.txt";
    fetch(path)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Document not found");
        }
        return res.text();
      })
      .then((text) => {
        setContent(text);
      })
      .catch(() => setLoadError(true));
  }, []);

  const normalize = (value) =>
    value
      .toLowerCase()
      .replace(/[«»"]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const getAnchorId = (block) => {
    const lines = block.split("\n").map((line) => normalize(line));
    if (lines.some((line) => line.includes("правила пользования сайтом"))) {
      return "rules";
    }
    if (lines.some((line) => line.includes("договор публичной оферты"))) {
      return "offer";
    }
    if (
      lines.some((line) =>
        line.includes("политика конфиденциальности и обработки персональных данных")
      )
    ) {
      return "privacy";
    }
    return null;
  };

  const blocks = useMemo(() => {
    return content
      .replace(/\r\n/g, "\n")
      .trim()
      .split(/\n\s*\n/)
      .filter((block) => block.trim().length > 0);
  }, [content]);

  useEffect(() => {
    if (!location.hash || blocks.length === 0) {
      return;
    }
    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.hash, blocks]);

  return (
    <Container>
      <section className="main-content-block">
        <h1 className="main-title">
          Договор публичной оферты и правила пользования сайтом
        </h1>
        <div className="offer-nav">
          <a href="#offer" className="offer-nav-link">
            Договор публичной оферты
          </a>
          <a href="#rules" className="offer-nav-link">
            Правила пользования сайтом
          </a>
          <a href="#privacy" className="offer-nav-link">
            Политика конфиденциальности и обработки персональных данных
          </a>
        </div>
        {loadError ? (
          <p className="offer-help">
            Не удалось загрузить документ. Проверьте файл
            <span className="inline-block px-1">/public/offer.txt</span>.
          </p>
        ) : (
          <div className="offer-text">
            {blocks.map((block, index) => {
              const lines = block.split("\n");
              const anchorId = getAnchorId(block);
              return (
                <p
                  key={`blk-${index}`}
                  id={anchorId || undefined}
                  className={`offer-paragraph ${anchorId ? "offer-anchor" : ""}`}
                >
                  {lines.map((line, lineIndex) => (
                    <React.Fragment key={`ln-${index}-${lineIndex}`}>
                      {line}
                      {lineIndex < lines.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              );
            })}
          </div>
        )}
      </section>
    </Container>
  );
}

export default OfferPage;
